export enum XpressDeliveryStatus {
	RepeatScheduled = 0,
	New = 1,
	RiderAssigning = 2,
	RiderAssigned = 3,
	DepartedToPickup = 4,
	PickedUp = 5,
	ArrivedToDrop = 6,
	Completed = 7,
	Canceled = 8,
	Rejected = 9,
	Expired = 10,
	ArrivedToPickup = 11,
	RiderAccept = 12,
	RiderAcceptB2B = 13
}

